module.exports = __webpack_public_path__ + "resources/img/img_private_region_gov.48a0fd1e4af9783147c29b4301864234.png";